import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/system";
import { Button, Typography, useMediaQuery } from "@mui/material";
import ProductDetails from "./ProductDetails";
import SearchGaugeView from "./SearchGaugeView";
import { connect } from "react-redux";
import { gaugeActions, homeActions } from "actions";
import AlternativeListView from "./AlternativeListView";
import SmallModalViewTemplate from "./SmallModalViewTemplate";
import ShareHCPApp from "pages/home/ShareHCPApp";
import CouponQRCode from "components/CouponQRCode";

const MedicationDetailsContainer = (props) => {
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  const matchesMinSmToMd = useMediaQuery("(min-width:601px)");
  const matchesMaxSmToMd = useMediaQuery("(max-width:900px)");
  const matchesMinMdToLg = useMediaQuery("(min-width:901px)");
  const matchesMaxMdToLg = useMediaQuery("(max-width:1200px)");
  const matches500MaxWidth = useMediaQuery("(max-width:500px)");

  const storedZipData = JSON.parse(localStorage.getItem("storedZipData"));

  const {
    zipData,
    productDetailId,
    openInsurance,
    alternateList,
    copayPrice,
    copayPriceIsProgress,
    sortByPrice,
    //storeAppData,
    handleGaugeAndCouponView,
    setCouponOrGenericListTitle,
    organizationInfo,
    couponDataObj,
    selectedProduct,
    setGaugeInit,
    gaugeInit,
    showGauge,
    openSearchButton,
    setOpenSearchButton,
    setShowGauge,
    editFromInsurace,
    setEditFromInsurace,
    savingsBtnAutoForward,
    setSavingsBtnAutoForward,
    hasUserSelectedInsurance,
    discountData,
    updateLowestCouponPrice,
    match,
    retailDataError,
    retailDataIsSuccess,
    retailDataisProgress,
    discountPriceError,
    discountPriceIsSuccess,
    discountPriceisProgress,
    alternateView = false,
    setAlternateView,
  } = props;

  // eslint-disable-next-line no-unused-vars
  const [showInsurance, setShowInsurance] = useState(false);
  const [showAlternatives, setShowAlternatives] = useState(alternateView);
  const [zipValueStatus, setZipValueStatus] = useState("none");
  const zipInputRef = useRef(null);
  const insuranceRef = useRef(null);
  const [triggerGetSavings, setTriggerGetSavings] = useState(false);
  // const hasUserSelectedInsurance = localStorage.getItem(
  //   "hasUserSelectedInsurance"
  // );
  const isHCPTemplate =
    organizationInfo?.type?.toLowerCase() === "h" &&
    organizationInfo?.app?.appCode?.toLowerCase() == "hcp";

  const showProductDetailSelectionFlag =
    organizationInfo?.organizationOptionJson?.showProductDetailSelectionFlag?.toLowerCase() ===
    "y";
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [selectedList, setSelectedList] = useState({});

  useEffect(() => {
    if (openSearchButton) {
      setShowAlternatives(false);
    }
  }, [openSearchButton]);

  const getInsuranceStatus = (show) => {
    setShowInsurance(show);
  };

  const getLowestList = async () => {
    if (selectedProduct?.type?.toLowerCase() === "b") {
      // storeAppData("alternate", {
      //   productDetailId: productDetailId,
      //   zipCode: storedZipData?.zipCode || zipData?.zipCode,
      // });
      updateLowestCouponPrice(discountData);
    } else {
      updateLowestCouponPrice(couponDataObj);
    }
  };
  const enterZipCode = () => {
    setOpenSearchButton(true);
    // `current` points to the mounted text input element
    setTimeout(() => {
      zipInputRef.current.focus();
    }, 100);
  };

  useEffect(() => {
    // Based on zip value status we need to either send the reset type
    // this should only happen when we enter or update a zip value
    if (
      zipData &&
      Object.keys(zipData).length &&
      productDetailId !== "" &&
      zipValueStatus === "reload"
    ) {
      // resetData("zipCodeReset");
    }
  }, [zipData.zipCode]);

  useEffect(() => {
    if (gaugeInit) {
      setSavingsBtnAutoForward(true);
    }
  }, [gaugeInit]);

  return (
    <Box
      sx={{ height: "100%", position: "relative", backgroundColor: "white" }}
    >
      <Box
        sx={{
          backgroundColor: `${organizationInfo?.colorSchemeJson?.gaugeColor?.backgroundColor}  !important`,
          minHeight: matches500MaxWidth ? 300 : 400,
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
          display: openSearchButton ? "none" : "block",
        }}
        pt={matchesMinWidth ? 14 : 16}
        pb={matchesMinWidth ? 2 : 0}
      >
        <Box sx={{ display: "flex" }}>
          <Box
            sx={{
              width: matches500MaxWidth ? "280px" : "25rem",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <SearchGaugeView
              setTriggerGetSavings={setTriggerGetSavings}
              triggerGetSavings={triggerGetSavings}
              openInsurance={openInsurance}
              setSavingsBtnAutoForward={setSavingsBtnAutoForward}
              savingsBtnAutoForward={savingsBtnAutoForward}
              showGauge={showGauge}
              setGaugeInit={setGaugeInit}
              gaugeInit={gaugeInit}
              getInsuranceStatus={getInsuranceStatus}
              openSearchButton={openSearchButton}
              setOpenSearchButton={setOpenSearchButton}
              onSavingsClick={(value) => {
                if (value === "couponDetails") {
                  handleGaugeAndCouponView("couponDetails");
                } else {
                  handleGaugeAndCouponView("genericList");
                }
              }}
            />
          </Box>
          {Object.keys(couponDataObj).length && couponDataObj?.qrCodeUrl && (
            <CouponQRCode />
          )}
        </Box>
        <Box>
          {/* {showInsurance && hasUserSelectedInsurance==='N'
            !Object.keys(selectedInsurance).length &&
            !storedInsuranceData && (
              <Box
                pb={2}
                sx={{
                  width: matchesMinWidth ? "280px" : "25rem",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                <Button
                  variant="large"
                  ref={insuranceRef}
                  sx={{
                    width: "100%",
                    minWidth: matchesMinWidth ? "280px" : undefined,
                  }}
                  onClick={() => openInsurance("insurance")}
                >
                  ADD INSURANCE FOR LOWEST PRICE
                </Button>

                <Box
                  variant="h1LatoBold"
                  sx={{
                    color: "#FFF",
                    letterSpacing: "0.6px",
                    display: "flex",
                    fontSize: "16px",
                    justifyContent: "center",
                    paddingTop: "4%",
                    textDecoration: "underline",
                    fontFamily: "Lato-Bold",
                    cursor: "pointer",
                    position: "relative",
                    textAlign: "center",
                  }}
                  onClick={() => {
                    clearCommercialInsurance();
                    notInsured();
                    updateGTMDataLayer({
                      event: "Search_medication_uninsured",
                      insurance_type: "I'M CURRENTLY UNINSURED",
                      insurance: "I'M CURRENTLY UNINSURED",
                      page: "Search for medication",
                      screen: "Search for medication",
                      screen_referrer: "Search for medication",
                    });
                  }}
                >
                  I do not wish to compare insurance coverage
                </Box>
              </Box>
            )} */}

          {!zipInputRef?.current?.value &&
          !storedZipData &&
          showProductDetailSelectionFlag ? (
            <Box
              mb={3}
              pb={2}
              sx={{
                width: matchesMinWidth ? "280px" : "25rem",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <Button
                variant="large"
                sx={{
                  width: "100%",
                  minWidth: matchesMinWidth ? "280px" : undefined,
                }}
                onClick={() => enterZipCode()}
                id="zipcode-btn"
              >
                ENTER ZIP CODE
              </Button>
            </Box>
          ) : null}

          {retailDataError !== null &&
            retailDataError?.message &&
            retailDataError?.data === null &&
            !retailDataIsSuccess &&
            !retailDataisProgress && (
              <Box
                mt={2}
                mb={2}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Typography
                  variant="text4"
                  sx={{
                    textAlign: "center",
                    color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                  }}
                >
                  {retailDataError?.message}
                </Typography>
              </Box>
            )}

          {discountPriceError !== null &&
            discountPriceError?.message &&
            discountPriceError?.data === null &&
            !discountPriceIsSuccess &&
            !discountPriceisProgress && (
              <Box
                mt={2}
                mb={2}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Typography
                  variant="text4"
                  sx={{
                    textAlign: "center",
                    color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                  }}
                >
                  {discountPriceError?.message}
                </Typography>
              </Box>
            )}

          {hasUserSelectedInsurance === "N" &&
            copayPrice?.couponFoundFlag === "Y" &&
            Object.keys(couponDataObj).length !== 0 && (
              <>
                <Box
                  mt={matchesMinWidth ? 0 : 0}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Button
                    variant="large"
                    id="getSavingsBtn"
                    style={{
                      minWidth: matchesMinWidth ? "280px" : undefined,
                    }}
                    onClick={() => openInsurance("select_insurance")}
                  >
                    Check Coupon Eligibility
                  </Button>
                </Box>
              </>
            )}

          {copayPrice?.copayPriceMin !== "NA" &&
            copayPrice?.copayPriceMax !== "NA" &&
            hasUserSelectedInsurance === "Y" &&
            (copayPrice?.couponNotFoundTitle?.toLowerCase() ===
              "not eligible" ||
              copayPrice?.couponNotFoundTitle?.toLowerCase() ===
                "not available") && (
              <Box
                pb={matchesMinWidth ? 0 : "0px"}
                sx={{
                  width: matchesMinWidth ? undefined : "30rem",
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    variant="h4LatoBold"
                    component="div"
                    sx={{
                      color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                      margin: "1rem auto 0",
                      display: "block",
                      width: "296px",
                      lineHeight: "20px",
                      letterSpacing: "0.4px",
                    }}
                  >
                    {copayPrice?.couponNotFoundText}
                  </Typography>
                  <br />
                  <Typography
                    variant="h4LatoRegular"
                    sx={{
                      color: `${organizationInfo?.colorSchemeJson?.defaultColorScheme?.textColor}`,
                      //opacity: !isShowBackgroundAssets ? 0.7 : 1,
                      fontSize: "12px",
                    }}
                  >
                    *{copayPrice?.disclaimerText}
                  </Typography>
                </Box>
              </Box>
            )}

          {Object.keys(copayPrice || {}).length > 0 &&
            !copayPriceIsProgress && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: matchesMinWidth ? "column" : undefined,
                  alignItems: matchesMinWidth ? "center" : undefined,
                  paddingBottom: matchesMinWidth ? 0 : "12px",
                }}
              >
                {Object.keys(copayPrice).length &&
                copayPrice?.alternateFlag === "Y" &&
                alternateList &&
                alternateList.length ? (
                  <Box
                    mt={matchesMinWidth ? 0 : 2}
                    sx={{ marginRight: matchesMinWidth ? undefined : "1rem" }}
                  >
                    <Button
                      variant="filled"
                      sx={{
                        textAlign: "center",
                        minWidth:
                          (matchesMinMdToLg && matchesMaxMdToLg) ||
                          (matchesMinSmToMd && matchesMaxSmToMd)
                            ? "230px"
                            : "300px",
                      }}
                      onClick={() => {
                        setShowAlternatives(true);
                      }}
                    >
                      <span
                        style={{
                          fontSize:
                            (matchesMinMdToLg && matchesMaxMdToLg) ||
                            (matchesMinSmToMd && matchesMaxSmToMd)
                              ? "12px"
                              : "16px",
                        }}
                      >
                        {isHCPTemplate ? (
                          <>
                            LOWER COST COVERED ALTERNATIVES <br />
                            FOR CONSIDERATION
                          </>
                        ) : (
                          <>
                            LOWER COST ALTERNATIVES TO <br /> DISCUSS WITH YOUR
                            PRESCRIBER
                          </>
                        )}
                      </span>
                    </Button>
                  </Box>
                ) : null}

                {(Object.keys(copayPrice).length &&
                  copayPrice?.alternateFlag === "Y") ||
                (Object.keys(couponDataObj).length &&
                  Object.keys(copayPrice).length &&
                  parseFloat(
                    copayPrice?.copayPriceMax?.replace("$", "").trim()
                  ) <
                    parseFloat(
                      couponDataObj?.couponPrice?.replace("$", "").trim() ||
                        couponDataObj?.discountPrice?.replace("$", "").trim()
                    )) ? (
                  <>
                    {selectedProduct?.type?.toLowerCase() === "b" &&
                      copayPrice?.alternateFlag === "N" && (
                        <Box
                          mt={2}
                          sx={{
                            marginRight: matchesMinWidth ? undefined : "1rem",
                          }}
                          mb={2}
                        >
                          <Button
                            variant="largeOutline"
                            sx={{
                              backgroundColor: "#fff",
                              borderColor: "#fff",
                              textAlign: "center",
                              minWidth:
                                (matchesMinMdToLg && matchesMaxMdToLg) ||
                                (matchesMinSmToMd && matchesMaxSmToMd)
                                  ? "230px"
                                  : "300px",
                            }}
                            onClick={() => {
                              if (isHCPTemplate) {
                                setShowSharePopup(true);
                                setSelectedList(discountData);
                              } else {
                                setTriggerGetSavings(true);
                              }
                            }}
                          >
                            <span
                              style={{
                                fontSize:
                                  (matchesMinMdToLg && matchesMaxMdToLg) ||
                                  (matchesMinSmToMd && matchesMaxSmToMd)
                                    ? "12px"
                                    : "16px",
                              }}
                            >
                              <>
                                {isHCPTemplate ? (
                                  <>
                                    SEND {couponDataObj?.discountPrice} <br />
                                    COUPON PRICE TO PATIENT
                                  </>
                                ) : (
                                  <>
                                    GET {couponDataObj?.discountPrice} <br />
                                    COUPON PRICE
                                  </>
                                )}
                              </>
                            </span>
                          </Button>
                        </Box>
                      )}
                    <Box mt={2} mb={2}>
                      <Button
                        variant="largeOutline"
                        sx={{
                          // backgroundColor: "#fff",
                          // borderColor: "#fff",
                          textAlign: "center",
                          minWidth:
                            (matchesMinMdToLg && matchesMaxMdToLg) ||
                            (matchesMinSmToMd && matchesMaxSmToMd)
                              ? "230px"
                              : "300px",
                        }}
                        onClick={() => {
                          if (isHCPTemplate) {
                            setShowSharePopup(true);
                            setSelectedList(discountData);
                          } else {
                            setShowSharePopup(false);
                            setSelectedList({});
                            getLowestList();
                            sortByPrice(true);
                            handleGaugeAndCouponView("genericList");
                          }
                        }}
                      >
                        <span
                          style={{
                            fontSize:
                              (matchesMinMdToLg && matchesMaxMdToLg) ||
                              (matchesMinSmToMd && matchesMaxSmToMd)
                                ? "12px"
                                : "16px",
                          }}
                        >
                          {selectedProduct?.type?.toLowerCase() === "b" ? (
                            <>
                              {isHCPTemplate ? (
                                <>
                                  SEND {discountData.discountPrice} <br />{" "}
                                  DISCOUNT PRICE TO PATIENT
                                </>
                              ) : (
                                <>
                                  GET {discountData.discountPrice} <br />{" "}
                                  DISCOUNT PRICE
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              {isHCPTemplate ? (
                                <>
                                  SEND {couponDataObj?.discountPrice} <br />{" "}
                                  COUPON PRICE TO PATIENT
                                </>
                              ) : (
                                <>
                                  GET {couponDataObj?.discountPrice} <br />
                                  COUPON PRICE
                                </>
                              )}
                            </>
                          )}
                        </span>
                      </Button>
                    </Box>
                  </>
                ) : null}
              </Box>
            )}
        </Box>
      </Box>
      <Box>
        <ProductDetails
          match={match}
          openInsurance={openInsurance}
          zipInputRef={zipInputRef}
          insuranceRef={insuranceRef}
          showAlternatives={showAlternatives}
          onDetailsLoad={(value) => setZipValueStatus(value)}
          setGaugeInit={setGaugeInit}
          setShowGauge={setShowGauge}
          gaugeInit={gaugeInit}
          setSavingsBtnAutoForward={setSavingsBtnAutoForward}
          savingsBtnAutoForward={savingsBtnAutoForward}
          openSearchButton={openSearchButton}
          setOpenSearchButton={setOpenSearchButton}
          editFromInsurace={editFromInsurace}
          setEditFromInsurace={setEditFromInsurace}
        />
      </Box>
      {showAlternatives || alternateView ? (
        <SmallModalViewTemplate
          onCancelAlternatives={() => {
            setShowAlternatives(false);
          }}
        >
          <AlternativeListView
            onCancelAlternatives={() => {
              setShowAlternatives(false);
              setAlternateView(false);
            }}
            onListClick={(option) => {
              setCouponOrGenericListTitle(option.selectedItem);
              sortByPrice(true);
              if (option.type === "couponDetails") {
                handleGaugeAndCouponView("couponDetails", true);
              } else {
                handleGaugeAndCouponView("genericList", true);
              }
              // setShowAlternatives(false);
            }}
          />
        </SmallModalViewTemplate>
      ) : null}
      {showSharePopup && (
        <>
          <ShareHCPApp
            setShowSharePopup={setShowSharePopup}
            shareCoupon={showSharePopup}
            shareApp={false}
            couponData={selectedList}
            viewCouponLink={true}
            viewCouponLinkClick={() => {
              setShowSharePopup(false);
              setSelectedList({});
              getLowestList();
              sortByPrice(true);
              handleGaugeAndCouponView("genericList");
            }}
          />
        </>
      )}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    zipData: state.zipData.data,
    selectedInsurance: state.insuranceList.selectedInsurance,
    hasUserSelectedInsurance: state.insuranceList.hasUserSelectedInsurance,
    productDetailId: state.productDetails.productDetailId,
    alternateList: state.alternateList.data,
    copayPrice: state.copayPrice.data,
    copayPriceIsProgress: state.copayPrice.isProgress,
    zipDataStatus: state.zipData.zipDataStatus,
    appQuantity: state.productDetails.appQuantity,
    authData: state.authentication.authData || {},
    organizationInfo: state.organizationInfo.data,
    couponDataObj: state.couponPrice.data,
    selectedProduct: state.home.selectedProduct,
    discountData: state.discountPrice.data,
    retailDataError: state.retailPrice.error,
    retailDataIsSuccess: state.retailPrice.success,
    retailDataisProgress: state.retailPrice.isProgress,
    discountPriceError: state.discountPrice.error,
    discountPriceIsSuccess: state.discountPrice.success,
    discountPriceisProgress: state.discountPrice.isProgress,
  };
};

const mapDispatchToProps = {
  storeAppData: (type, value) => homeActions.storeAppData(type, value),
  resetData: (value) => homeActions.resetData(value),
  sortByPrice: (value) => homeActions.sortByPrice(value),
  saveUserInsurance: (value) => homeActions.saveUserInsurance(value),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
  updateLowestCouponPrice: (param) =>
    gaugeActions.updateLowestCouponPrice(param),
};

export default connect(mapStateToProps, mapDispatchToProps)(MedicationDetailsContainer);
